module.exports = __webpack_public_path__ + "static/img/2.9078605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/2.jpg
// module id = ggwM
// module chunks = 12